export default class Inventory {
  constructor(items = []) {
    this.levelsOfGuidance = new Map([
      [0, 'inactive'],
      [1, 'startAction'],
      [2, 'monitoredAction'],
      [3, 'maintainedBehavior'],
    ]);

    this.items = this.transform(items);
  }

  transform(items) {
    return items.map((item) => {
      const stepOne = this.parseExtraInformation(item);
      const stepTwo = this.mapLevelOfGuidance(stepOne);

      return stepTwo;
    });
  }

  parseExtraInformation(item) {
    if (item.extraInformation) {
      item.extraInformation = JSON.parse(item.extraInformation);

      if (item.extraInformation.dependence) {
        switch (item.extraInformation.dependence) {
          case 'high':
                item.extraInformation.dependence = 'smokingRiskProfile.highDependence';
                break;
            case 'low':
                item.extraInformation.dependence = 'smokingRiskProfile.lowDependence';
                break;
            default:
                item.extraInformation.dependence = '';
        }
      }

      return {
        ...item,
        // Do we even need to duplicate it here?
        extraInformation: item.extraInformation,
      };
    }

    return item;
  }

  mapLevelOfGuidance(item) {
    if (item.levelOfGuidance) {
      return {
        ...item,
        levelOfGuidance: this.levelsOfGuidance.get(item.levelOfGuidance),
      };
    }

    return item;
  }

  get(key) {
    const item = this.items.find((item) => item.key === key);
    return item || {};
  }
}
